import { OperatorUserOperatorUserPermissionName } from '@xbcb/client-types';
import { AccountType } from '@xbcb/shared-types';
import { AppRecordKebabMenuItem } from '../../types';
import { setModal } from 'actions';
import { ModalKey } from 'types';
import { isIdpFeatureEnabled } from 'featureFlags';

export const submitAsIDP: AppRecordKebabMenuItem = {
  text: 'Submit for Immediate Release',
  key: 'submitIDP',
  action: async ({ record, dispatch }) => {
    dispatch(
      setModal({
        key: ModalKey.VALIDATE_US_ENTRY_RELEASE,
        props: {
          visible: true,
          record: record,
          idpEnabled: record.immediateDeliveryIndicator,
        },
      }),
    );
  },
  show: ({ currentUser }): boolean => {
    const isOperator = currentUser.accountType === AccountType.OPERATOR;
    const isAdmin =
      isOperator &&
      currentUser.operatorUserPermissions?.operatorUser?.some(
        (permission: any) =>
          permission.name === OperatorUserOperatorUserPermissionName.ADMIN,
      );
    return isIdpFeatureEnabled && isAdmin;
  },
};
